import { typographyHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';

export const SearchPageFormLabel = styled.span`
  ${typographyHelper('subtitle01')}
  font-weight: 500;
  font-size: 1rem;
`;
